"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionDetailsUpsert = exports.SubscriptionDetailsUpdate = exports.SubscriptionDetailsCreate = exports.SubscriptionDetails = exports.BillingFrequencyUnitLabels = exports.BillingFrequencyUnit = exports.BillingFrequencyUnits = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const ServiceEvent_1 = require("./ServiceEvent");
/**@deprecated - use the common Duration instead */
exports.BillingFrequencyUnits = ['week', 'month', 'day'];
/**@deprecated - use the common Duration instead */
exports.BillingFrequencyUnit = typebox_1.Type.Union(exports.BillingFrequencyUnits.map((unit) => typebox_1.Type.Literal(unit)));
/**@deprecated - use the common Duration instead */
exports.BillingFrequencyUnitLabels = {
    day: 'Day',
    week: 'Week',
    month: 'Month',
};
exports.SubscriptionDetails = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    billingFrequency: typebox_1.Type.Integer(),
    billingFrequencyUnit: exports.BillingFrequencyUnit,
    billingDay: typebox_1.Type.Integer({ minimum: 1 }),
    addToInvoiceWhen: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 1 })),
    futureServiceOrderCount: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
    startDate: typebox_1.Type.String({ format: 'date' }),
    endDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    active: typebox_1.Type.Boolean(),
    internalNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    periodicEvents: typebox_1.Type.Array(ServiceEvent_1.ServiceEventTemplate),
    metadata: common_1.MetaData,
});
exports.SubscriptionDetailsCreate = typebox_1.Type.Omit(exports.SubscriptionDetails, ['id', 'metadata']);
exports.SubscriptionDetailsUpdate = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.SubscriptionDetails, ['id', 'metadata']));
exports.SubscriptionDetailsUpsert = typebox_1.Type.Intersect([
    exports.SubscriptionDetailsCreate,
    typebox_1.Type.Object({
        id: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    }),
]);
//# sourceMappingURL=SubscriptionDetails.js.map